import React, { useEffect } from "react";
import { Row } from "react-bootstrap";
import "./security-details.scss";
const SecuirityDetailsSummary = (props) => {
  const Data = props?.formDataSecuirityHdfc;
  useEffect(() => {
    props.Review();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props?.ic_id]);
  return (
    <div className="security-details-summary">
      <Row>
        <div class="form-group">
          <div>
            <label style={{ fontSize: "14px", paddingRight: "60px" }}>
              Security Incident and Loss history :- Are you or your family
              members aware of any incident which may lead to any loss or claim
              under any of the section of the policy you are applying for?
            </label>
          </div>
          <div style={{ marginTop: "-11px", fontSize: "13px" }}>
            {Data?.IsSecurityIncidentandLossHistory == "N" ? "NO" : "YES"}
          </div>
        </div>
      </Row>
      {Data?.IsSecurityIncidentandLossHistory == "Y" && (
        <Row>
          <div class="form-group">
            <div style={{ marginTop: "-11px", fontSize: "13px" }}>
              {Data?.backupText}
            </div>
          </div>
        </Row>
      )}
      <b style={{ marginTop: "7px", marginBottom: "10px", fontSize: "20px" }}>
        Other Questions
      </b>
      <Row>
        <div class="form-group">
          <div>
            <label style={{ fontSize: "14px", paddingRight: "60px" }}>
              Is anti-virus software installed in your devices?
            </label>
          </div>
          <div style={{ marginTop: "-11px", fontSize: "13px" }}>
            {Data?.IsAntiVirusInstalledInDevices == "N" ? "NO" : "YES"}
          </div>
        </div>
      </Row>
      <Row>
        <div class="form-group">
          <div>
            <label style={{ fontSize: "14px", paddingRight: "60px" }}>
              Do you change password of your device regularly?
            </label>
          </div>
          <div style={{ marginTop: "-11px", fontSize: "13px" }}>
            {Data?.IsDevicePasswordChangeRegularly == "N" ? "NO" : "YES"}
          </div>
        </div>
      </Row>
      <Row>
        <div class="form-group">
          <div>
            <label style={{ fontSize: "14px", paddingRight: "60px" }}>
              Occupation
            </label>
          </div>
          <div style={{ marginTop: "-11px", fontSize: "13px" }}>
            {Data?.Occupation}
          </div>
        </div>
        <div class="form-group">
          <div>
            <label style={{ fontSize: "14px", paddingRight: "60px" }}>
              Annual Income
            </label>
          </div>
          <div style={{ marginTop: "-11px", fontSize: "13px" }}>
            {Data?.AnnualIncome}
          </div>
        </div>
        <div class="form-group">
          <div>
            <label style={{ fontSize: "14px", paddingRight: "60px" }}>
              Source Of Fund
            </label>
          </div>
          <div style={{ marginTop: "-11px", fontSize: "13px" }}>
            {Data?.SourceOfFund}
          </div>
        </div>
        <div class="form-group">
          <div>
            <label style={{ fontSize: "14px", paddingRight: "60px" }}>
              Devices
            </label>
          </div>
          <div style={{ marginTop: "-11px", fontSize: "13px" }}>
            {Data?.Devices}
          </div>
        </div>
      </Row>
    </div>
  );
};

export default SecuirityDetailsSummary;
